import React from "react";
import TransactionsUploadScreen from "../Containers/Transactions/TransactionsUploadScreen";

export const TransactionsUploadRoute = (): React.JSX.Element => <TransactionsUploadScreen />
